// @vendors
import React from "react";
import PropTypes from "prop-types";
import ClassNames from "classnames";
import moment from "moment";

// @common-components
import { OKWizard } from "components/OKWizard/OKWizard";
import { OKWizardError } from "components/OKWizard/OKWizardError/OKWizardError";
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
import { OKSummaryHireCardC } from "components/OKWizard/OKWizardSummary/OKWizardSummary";

// @steps
import { ModifyCharityCardData } from "../../steps/modifyCharityCardData";
import { ConfirmCharityCardData } from "../../steps/confirmCharityCardData";

// @utils
import { i18n } from "core/i18n";
const { formatText, FormattedText } = i18n;
const { recordPath, PROC_END } = require("utilities/tagging");

// @constants
import { LIMIT_CHARITY_AMOUNT, ONG } from "constants/index";

const WizardSpain = ({
    propsWizard,
    charityFoundationsError,
    submitResults,
    cardAccount,
    modifyCharity,
    minAmountStateValue,
    maxAmountStateValue,
    charityFoundations,
    immCard,
    fullContractNumber,
    beneficiaryName
}) => {
    
    const {
        submitSuccessful,
        minAmount,
        maxAmount,
        typeChange,
        allwizard,
        
    } = propsWizard;

    const gridClass = ClassNames("grid-view__body col-xs-12 ", {
        "col-md-12": submitSuccessful,
        "col-md-8": !submitSuccessful
    });

    const goBack = {
        label: <FormattedText value="cardBlock-backToCards" />,
        url: "/myprofile/cards",
        action: () => {}
    };

    const maxAmountValue =
        maxAmount === LIMIT_CHARITY_AMOUNT
            ? formatText("ngoAmounts-maxLimit")
            : maxAmount;

    const buildCardSummary = () => {
        return (
            <div className="col-xs-12 col-md-4">
                <div className="grid-view--content-position-negative">
                    <OKSummaryHireCardC
                        selectedAccount={cardAccount}
                        type="solidarity"
                        modifyCharity={true}
                        creditType="solidarity-card"
                        ong={
                            modifyCharity && minAmount === undefined
                                ? charityFoundations
                                : propsWizard.charityFoundations.toJS()
                        }
                        showAddress={false}
                        immCard={immCard}
                        showCardIBAN={true}
                        solidarityCardLimits={{
                            min:
                                modifyCharity && minAmount === undefined
                                    ? minAmountStateValue
                                    : minAmount,
                            max:
                                modifyCharity && maxAmount === undefined
                                    ? maxAmountStateValue
                                    : maxAmount
                        }}
                    />
                </div>
            </div>
        );
    };

    const buildWizardContent = () => {
        if (!!submitSuccessful) {
            recordPath(window.location.pathname, "proc-ajustes-ONG", PROC_END);
            return (
                <div className="col-xs-12 col-xs-offset-0 col-md-8 col-md-offset-2">
                    <div className="grid-view--content-position-negative">
                        <WizardSuccess
                            successMessage={
                                <FormattedText
                                    value={`modifyCharityCard-successTitle${typeChange}`}
                                />
                            }
                            successSubMessage={
                                <FormattedText
                                    value={`modifyCharityCard-subMessage${typeChange}`}
                                    injectedStrings={[
                                        moment()
                                            .endOf("month")
                                            .add(1, "days")
                                            .format("DD-MM-YYYY")
                                    ]}
                                />
                            }
                            mainButton={goBack}
                        >
                            <div className="row">
                                <div className="col-xs-6">
                                    <FormattedText
                                        value="modifySolidarityCard-cardDataContractNumberTitle"
                                        className="hire-confirmation__summary-title"
                                    />
                                    <div style={{ marginBottom: "10px" }}>
                                        {fullContractNumber}
                                    </div>
                                    <FormattedText
                                        value="hireSolidarityCard-selectedNGOMainBodySummaryMessage"
                                        className="hire-confirmation__summary-title"
                                    />
                                    {propsWizard.charityFoundations.map(
                                        (charityFoundation, index) => (
                                            <div key={index}>{charityFoundation.getIn(['suggestion', 'name'])}</div>
                                        )
                                    )}
                                </div>
                                <div className="col-xs-6">
                                    <FormattedText
                                        value="modifySolidarityCard-cardDataHolderNameTitle"
                                        className="hire-confirmation__summary-title"
                                    />
                                    <div style={{ marginBottom: "10px" }}>
                                        {beneficiaryName}
                                    </div>
                                    <div className="hire-confirmation__limit-value">
                                        <FormattedText
                                            value="common-minimumLimit"
                                            className="hire-confirmation__summary-title"
                                        />
                                        :
                                        <div>
                                            {`${minAmount} €/`}
                                            <FormattedText
                                                value="common-month"
                                                format="lowercase"
                                            />
                                        </div>
                                    </div>
                                    <div className="hire-confirmation__limit-value">
                                        <FormattedText
                                            value="common-maximumLimit"
                                            className="hire-confirmation__summary-title"
                                        />
                                        :
                                        <div>
                                            {maxAmount === LIMIT_CHARITY_AMOUNT
                                                ? maxAmountValue
                                                : `${maxAmountValue}€/`}
                                            {maxAmount !==
                                                LIMIT_CHARITY_AMOUNT && (
                                                <FormattedText
                                                    value="common-month"
                                                    format="lowercase"
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </WizardSuccess>
                    </div>
                </div>
            );
        } else if (
            !!charityFoundationsError ||
            (__CONTACT_CENTER__ && allwizard.get("error"))
        ) {
            return (
                <div className="row">
                    <div className={gridClass}>
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                <div className="col-xs-12 col-md-12 col-md-offset-3">
                                    <OKWizardError
                                        errorMessage={
                                            <FormattedText value="hireCardOpenDebit-errorTitleGeneric" />
                                        }
                                        mainButton={goBack}
                                    >
                                        <FormattedText value="hireCardRevolving-errorTextGeneric" />
                                    </OKWizardError>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="row">
                    <div className={gridClass}>
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                <OKWizard
                                    defaultRecordProcess={false}
                                    submitResults={submitResults}
                                    goBackLink={`/myprofile/cards/${immCard.get('cardId')}/movements`}
                                    authorization={!!propsWizard.charityFoundations}
                                    type={ONG}
                                >
                                    <ModifyCharityCardData {...propsWizard} />
                                    <ConfirmCharityCardData {...propsWizard} />
                                </OKWizard>
                            </div>
                        </div>
                    </div>
                    {!submitSuccessful && buildCardSummary()}
                </div>
            );
        }
    };

    return buildWizardContent();
};

WizardSpain.propTypes = {
    propsWizard: PropTypes.object,
    charityFoundationsError: PropTypes.bool,
    submitResults: PropTypes.func,
    cardAccount: PropTypes.string,
    modifyCharity: PropTypes.bool,
    minAmountStateValue: PropTypes.number,
    maxAmountStateValue: PropTypes.number,
    charityFoundations: PropTypes.arrayOf.object,
    immCard: PropTypes.object,
    fullContractNumber: PropTypes.string,
    beneficiaryName: PropTypes.string
};

export default { WizardSpain };
